// extracted by mini-css-extract-plugin
export default {"sideBar":"MobileSidebar_sideBar__PMEoj"};